module.exports = __webpack_public_path__ + "static/media/addRed.79e21c9f.svg";